module.exports = {
    props: ['user', 'team'],

    data() {
        return {
            generalErrors: [],
            responseMessage: '',
            form: $.extend(true, new SparkForm({
                file: '',
            }), Spark.forms.bulkCsvCreateUsers)
        };
    },

    mounted() {
        console.log(this.team);
    },

    methods: {
        onFileChange(e) {
            const files = e.target.files || e.dataTransfer.files;

            if (!files.length) return;
            this.form.file = files[0];
        },

        update() {
            const form = this.form;
            const url = `/settings/${Spark.teamsPrefix}/${this.team.id}/bulk-csv-create-users`;
            let formData = new FormData();
            formData.append("file", form.file);
            this.generalErrors = [];

            new Promise((resolve, reject) => {
                form.startProcessing();
                this.responseMessage = '';

                axios.post(url, formData, {
                        headers: {'Content-Type': 'multipart/form-data'}
                    })
                    .then(response => {
                        form.finishProcessing();
                        this.responseMessage = response.data.message;
                        if (response.data.errors && response.data.errors.length) {
                            this.generalErrors = response.data.errors;
                        } else {
                            this.generalErrors = [];
                        }

                        this.$refs.fileInput.value = '';
                        this.form.file = '';

                        resolve(response.data);
                    })
                    .catch(errors => {
                        form.setErrors(errors.response.data.errors);

                        reject(errors.response.data);
                    });
            });
        }
    }
};
